<!--
  將列表的行分隔成左右兩塊
-->
<template>
  <div class="formRow row" :class="formClass">
    <div class="formRow-left col-lg-4" :class="leftClass">
      <slot name="left"></slot>
    </div>
    <div class="formRow-interval col-lg-1" v-if="ifInterval"></div>
    <div class="formRow-right xs-right" :class="rightClass + (ifInterval?' col-lg-7':'col-lg-8')">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formClass: {
      type: String,
      default: ""
    },
    leftClass: {
      type: String,
      default: ""
    },
    rightClass: {
      type: String,
      default: ""
    },
    ifInterval: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.formRow {
  position: relative;
  padding-bottom: 0.3rem;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  line-height: 0.3rem;
  .formRow-left {
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }
  .formRow-right {
    display: flex;
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }
}

@media (max-width: 850px) {
  .xs-right {
    display: flex;
  }
}

@media (max-width: 767px) {
  .xs-right {
    display: inline !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/formRow.vue